import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"height":"450px"} }

import { TaskListFilters } from '@/types/tasks/list/TaskListFilters';
import { TaskStatus } from '@/enums/tasks/TaskStatus';
import { onMounted, ref, inject, computed } from 'vue';
import displayErrorMessage from '@/utils/ErrorHandling';
import { getErrorMessage } from 'bright-logic-core/src/errors';
import { TaskListItem } from '@/types/tasks/list/TaskListItem';
import EditTaskModal from '@/components/tasks/edit-task-modal.vue';
import gridBase from '@/components/ui/grid/grid-base.vue';
import { DxColumn } from "devextreme-vue/data-grid";
import { AcquaintApiClient } from '@/services/AcquaintApiClient';
import { useCurrentUserStore } from '@/stores/CurrentUserStore';
import { CurrentUser } from '@/types/user/CurrentUser';


export default /*#__PURE__*/_defineComponent({
  __name: 'task-card',
  setup(__props) {

const acquaintApiClient = inject('AcquaintApiClient') as AcquaintApiClient;
const loadingTaskData = ref(false);
const tasks = ref<TaskListItem[]>();
const showEditTaskModal = ref(false);
const selectedTaskRecord = ref<TaskListItem>();
const currentUserStore = useCurrentUserStore();
const currentUser = ref<CurrentUser>();

onMounted(async () => {
    currentUser.value = await currentUserStore.getCurrentUserDetails();
    fetchTasksData();
});

// Fetch grid data
const taskFilters = computed(() => {
    const filters = new TaskListFilters();

    filters.status = TaskStatus.Outstanding;
    filters.assignedTo = [currentUser.value?.id ?? -1];

    return filters;
});

const fetchTasksData = async () => {
    loadingTaskData.value = true;

    try {
        tasks.value = await acquaintApiClient.httpPost(`app/tasks/list`, taskFilters.value);
    } catch (err) {
        displayErrorMessage(getErrorMessage(err));
        tasks.value = [];
    }

    loadingTaskData.value = false;
};

// Edit task record
const onRowClick = (e: TaskListItem) => {
  if (!e) {
    return;
  }
  selectedTaskRecord.value = e;
  showEditTaskModal.value = true;
};

const onTaskModalSaveClick = async () => {
  await fetchTasksData();
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(gridBase, {
        "data-source": tasks.value,
        "id-column-name": "id",
        loading: loadingTaskData.value,
        "show-action-button": false,
        "column-auto-width": true,
        onRowClick: onRowClick
      }, {
        columns: _withCtx(() => [
          _createVNode(_unref(DxColumn), {
            "data-field": "dueDate",
            caption: "Due Date",
            "data-type": "date",
            "hiding-priority": 8,
            format: "dd/MM/yyyy",
            width: 100
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "daysOverdue",
            caption: "Days Overdue",
            "hiding-priority": 6,
            width: 110
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "daysSinceUpdated",
            caption: "Since Updated",
            "hiding-priority": 5,
            width: 110
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "type.description",
            caption: "Type",
            "hiding-priority": 4,
            width: 150
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "priority.description",
            caption: "Priority",
            "allow-sorting": false,
            "hiding-priority": 3,
            width: 70
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "subjectDetails",
            caption: "Subject / Details",
            "hiding-priority": 9,
            width: 230
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "property.description",
            caption: "Property",
            name: "Priority",
            "hiding-priority": 1
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "contact.description",
            caption: "Contact",
            "hiding-priority": 2
          })
        ]),
        _: 1
      }, 8, ["data-source", "loading"])
    ]),
    _createVNode(EditTaskModal, {
      modelValue: showEditTaskModal.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showEditTaskModal).value = $event)),
      id: selectedTaskRecord.value?.id ?? 0,
      onSaveClick: onTaskModalSaveClick
    }, null, 8, ["modelValue", "id"])
  ], 64))
}
}

})